import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { PageViewModel, SortTypeEnum } from "src/domain/client";
import IProductListReport from "src/domain/event-emitters/product-list-report";
import ISearchQueryParams from "src/domain/extentions/search-query-params";
import { BrandService } from "src/services/brand.service";
import { ChannelRequestService } from "src/services/channel-request.service";
import { ErrorReporterService } from "src/services/error-reporter.service";
import { PageService } from "src/services/page.service";
import { ProductListService } from "src/services/product-list.service";
import { ThemeService } from "src/services/theme.service";

@Component({
  selector: "vw-search-page",
  templateUrl: "./search-page.component.html",
})
export class SearchPageComponent implements OnInit, OnDestroy {
  constructor(
    public themeService: ThemeService,
    private pageService: PageService,
    private brandService: BrandService,
    private errorReporter: ErrorReporterService,
    private route: ActivatedRoute,
    private router: Router,
    private channelRequestService: ChannelRequestService,
    private productListService: ProductListService,
  ) {}

  page?: PageViewModel;
  submittedSearchValue?: string;
  numberOfProductIDs?: number;

  private channelRequestUpdatesSubscription?: Subscription;
  private routeParamsSubscription?: Subscription;

  searchForm = new FormGroup({
    query: new FormControl(""),
  });

  ngOnInit(): void {
    this.getSearchPage();

    this.routeParamsSubscription = this.route.queryParams.subscribe(
      (params: ISearchQueryParams) => {
        if (params.query) {
          this.searchForm.patchValue({
            query: params.query,
          });

          this.search();
        }
      },
    );

    this.channelRequestUpdatesSubscription =
      this.channelRequestService.channelRequestUpdated$.subscribe(() => {
        this.search();
      });
  }

  ngOnDestroy(): void {
    this.routeParamsSubscription?.unsubscribe();
    this.channelRequestUpdatesSubscription?.unsubscribe();
  }

  sortChanged(sortType: SortTypeEnum): void {
    this.productListService.setSortType(sortType, this.submittedSearchValue);
  }

  reportNumberOfProductIDs(event: IProductListReport): void {
    this.numberOfProductIDs = event.numberOfProducts;
  }

  search(): void {
    if (!this.searchForm.value.query) {
      return;
    }

    this.submittedSearchValue = this.searchForm.value.query;

    const params = {
      emit: true,
      query: this.submittedSearchValue,
    };

    this.productListService.reloadSearch(params);
    this.numberOfProductIDs = 0;
  }

  formSubmit(): void {
    if (!this.searchForm.value.query) {
      return;
    }

    this.submittedSearchValue = this.searchForm.value.query;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { query: this.submittedSearchValue },
      queryParamsHandling: "merge",
    });
  }

  //////////

  private getSearchPage(): void {
    this.pageService
      .getStartPage(this.brandService.brandId)
      .then((startPage) => (this.page = startPage))
      .catch(this.errorReporter.handle);
  }
}
